import React from 'react'
import Select from "react-select";
import HelpModal from '../../../components/Modal/HelpModal';
import Notiofication from '../../../components/Modal/Notification';

function BarPanel() {
  return (
    <main>
      <div className="relative my-16 flex flex-col min-w-0 break-words w-full mb-6 shadow-lg bg-white rounded-lg p-4 border-0">

        <div className="flex justify-between py-3">
          <div>
            <h1 className="text-[#7B20C7] text-2xl">Bar Panel</h1>
          </div>
          <div className='flex gap-3'>
            <div> 
              <Select
                type="text"
                placeholder="Select Item"
                className="   placeholder-blueGray-300 text-blueGray-600 relative rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                required
              />
            </div>


            <Notiofication />
            <HelpModal />


          </div>
        </div>
      </div>
    </main>
  )
}

export default BarPanel

